/**
 * Reads a stored lab timing block. Runs saved before this change put Time to
 * Interactive in `fid`. That number is lab TTI, not field INP.
 */
export function readStoredLabTiming(
  metrics: { tti?: number | null; fid?: number | null } | null | undefined,
): { tti: number | null; legacyFid: boolean } {
  if (typeof metrics?.tti === "number") return { tti: metrics.tti, legacyFid: false };
  if (typeof metrics?.fid === "number") return { tti: metrics.fid, legacyFid: true };
  return { tti: null, legacyFid: false };
}
